// mutation-types.ts:
export enum MutationTypes {
  /**
   * 设置保存用户基本信息
   */
  SET_USER_INFO = "SET_USER_INFO",
  /**
   * 获取用户基本信息
   */
  GET_USER_INFO = "GET_USER_INFO",
  /**
   * 迁移用户数据
   */
  MIGRATION_USER_INFO = "MIGRATION_USER_INFO",
  /**
   * 清除用户基本信息
   */
  CLEAR_USER_INFO = "CLEAR_USER_INFO",
  /**
   * 赚了多少钱
   */
  MAKE_MONEY = "MAKE_MONEY",
  /**
   * 花了多少钱
   */
  COST_MONEY = "COST_MONEY",
  /**
   * 设置保存用户属性
   */
  SET_USER_PROPERTY = "SET_USER_PROPERTY",
  /**
   * 获取用户属性
   */
  GET_USER_PROPERTY = "GET_USER_PROPERTY",
  /**
   * 单独的设置血量
   */
  SET_CURRENT_HP = "SET_CURRENT_HP",
  /**
   * 将物品放入背包
   */
  PUT_ITEM_TO_PACKAGE = "PUT_ITEM_TO_PACKAGE",
  /**
   * 将物品移出背包
   */
  REMOVE_ITEM_TO_PACKAGE = "REMOVE_ITEM_TO_PACKAGE",
  /**
   * 批量移出背包
   */
  REMOVE_ITEM_TO_PACKAGE_MUL = "REMOVE_ITEM_TO_PACKAGE_MUL",
  /**
   * 获取背包物品
   */
  GET_PACKAGE = "GET_PACKAGE",
  /**
   * 穿戴装备
   */
  WEAR_EQUIP = "WEAR_EQUIP",
  /**
   * 脱装备
   */
  CAST_EQUIP = "CAST_EQUIP",
  /**
   * 获取穿戴装备
   */
  GET_EQUIP = "GET_EQUIP",
  /**
   * 设置无尽之塔层数
   */
  SET_TOWER_LEVEL = "SET_TOWER_LEVEL",
  /**
   * 获取无尽之塔层数
   */
  GET_TOWER_LEVEL = "GET_TOWER_LEVEL",
  /**
   * 设置状态
   */
  SET_USER_STATE = "SET_USER_STATE",
  /**
   * 整理装备
   */
  TIDY_PACKAGE = "TIDY_PACKAGE"
}
